<template>
    <div class="container mt-5">
      <!-- Display Loading State -->
      <div v-if="loading" class="text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-3">Loading event data...</p>
      </div>
      
      <!-- Display Event Information Once Loaded -->
      <div v-else class="event-container p-4 rounded shadow-sm">
        <!-- Heading Section -->
        <div class="text-center mb-4">
          <h3 class="display-4 text-primary">Kedves {{ event.childName }}!</h3>
          <p class="lead">Részt veszel a <strong>{{ event.setDate }}</strong> táncórán?</p>
        </div>
        <!-- Buttons Section -->
        <div v-if="resp === 0" class="d-flex justify-content-center">
          <button 
            class="btn btn-success btn-lg mx-3 px-4 py-2"
            @click="markAttendance(10)">
            <i class="fas fa-check-circle"></i> Igen
          </button>
          <button 
            class="btn btn-danger btn-lg mx-3 px-4 py-2"
            @click="markAttendance(20)">
            <i class="fas fa-times-circle"></i> Nem
          </button>
        </div>
        <div v-else>
            {{ resp }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        loading: true,  // Loading state before data is fetched
        event: {},      // Event data to display
        hash: this.hash,
        resp : null,
        resp_enum : {
          0  : 0,
          10 : "Visszajeleztél, hogy jössz!",
          11 : "Visszajeleztél, hogy megérkeztél az órára!",
          20 : "Visszajeleztél, hogy nem jössz!"
        }
      };
    },
    props: ['hash'],
    mounted() {
      // Fetch event data from the backend when the component is mounted
      this.fetchEventData();
    },
    methods: {
      async fetchEventData() {
        try {
          const response = await axios.get(`${this.$BACKEND_HOST}/api/checkhash/${this.hash}`);  // Replace with your backend API URL
          this.event = response.data;
          this.event.setDateBu = this.event.setDate;
          let date = new Date(this.event.setDate);
          this.event.setDate = date.toISOString().split('T')[0].replace(/-/g, '. ');
          this.loading = false; // Stop loading when data is fetched
          this.resp = this.resp_enum[this.event.childResp];
        } catch (error) {
          console.error('Error fetching event data:', error);
          this.loading = false;
        }
      },
      async markAttendance(status) {
        try {
          const payload = {
            status: status,
            child_id: this.event.childId,
            evnt_id  : this.event.grpId,
            set_date : this.event.setDateBu,
          };
          
          const response = await axios.post(this.$BACKEND_HOST + '/api/child/response', payload);  // Replace with your backend API URL

          if(response.data.message == "done")
          {
            this.resp = this.resp_enum[status];
            this.showToast('Visszajelzés sikeresen elküldve!', 'success');
          }
        } catch (error) {
          console.error('Error marking attendance:', error);
          this.showToast('Nem sikerült rögzíteni a visszajelzést. Kérjük, próbáld újra!', 'error');
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Optional: Customize styling if necessary */
  .container {
    max-width: 600px;
  }
  
  .event-container {
    background-color: var(--card-bg, #ffffff);
    border: 1px solid var(--color-border, #e2e8f0);
    border-radius: 12px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
    color: var(--color-text);
  }
  
  h3 {
    font-weight: 600;
  }
  
  button i {
    margin-right: 8px;
  }
  
  /* Button styles moved to components.css */
  </style>
  